module.exports = __webpack_public_path__ + "static/media/de-DE.5529cf32.md";